import { EFavoritesType, IOption, TRenovationType, TSellerType, TWallMaterial } from '../lib/types';
import { TUserRole } from 'api/types';
class Dictionary<T> {
  options: IOption<T>[] = [];

  constructor(options: IOption<T>[]) {
    this.options = options;
  }

  name(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.name : '';
  }

  label(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.label : '';
  }

  labelOrKey(key?: T | string) {
    const option = this.options.find((o) => o.key === key);
    return option ? option.label : key;
  }

  get namedOptions() {
    return this.options.flatMap((option) =>
      option.name ? [{ key: option.key, label: option.name }] : [],
    );
  }
}

export const WallMaterial = new Dictionary<TWallMaterial>([
  {
    key: 'Brick',
    label: 'Кирпич',
  },
  {
    key: 'Monolith',
    label: 'Монолит',
  },
  {
    key: 'BrickMonolith',
    label: 'Кирпич-монолит',
  },
  {
    key: 'Panel',
    label: 'Панель',
  },
  {
    key: 'Block',
    label: 'Блок',
  },
  { key: 'Wood', label: 'Дерево' },
  { key: 'Other', label: 'Остальные' },
]);

export const RenovationType = new Dictionary<TRenovationType>([
  {
    key: 'None',
    label: 'Нет',
  },
  {
    key: 'Cosmetic',
    label: 'Косметический',
  },
  {
    key: 'Euro',
    label: 'Евро',
  },
  {
    key: 'Designer',
    label: 'Дизайнерский',
  },
]);

export const SellerType = new Dictionary<TSellerType>([
  {
    key: 'Developer',
    label: 'Застройщик',
  },
  {
    key: 'Agency',
    label: 'Агентство',
  },
  {
    key: 'Owner',
    label: 'Собственник',
  },
  {
    key: 'Reit',
    label: 'Reit',
  },
  {
    key: 'Unknown',
    label: 'Неизвестен',
  },
]);

type TFavouritesType = keyof typeof EFavoritesType;

export const FavouritesType = new Dictionary<TFavouritesType>([
  {
    key: 'Personal',
    label: 'Личный',
  },
  {
    key: 'Shared',
    label: 'Совместный',
  },
  {
    key: 'Customer',
    label: 'Клиентский',
  },
]);

export const UsersType = new Dictionary<TUserRole | 'Employee'>([
  {
    key: 'Client',
    label: 'Клиент',
  },
  {
    key: 'Realtor',
    label: 'Риелтор',
  },
  {
    key: 'Employee',
    label: 'Работник',
  },
]);
